import { useQueryClient } from '@tanstack/react-query';
import { ChatMessageListItem } from 'src/@types/chat';
import { InfiniteData } from 'src/requests/todos';

type Props = {
  channelId: string;
  goToMessage?: string;
};

export const useUpdateMessage = ({ channelId, goToMessage }: Props) => {
  const queryClient = useQueryClient();
  const queryKey = ['channels', channelId, goToMessage];

  const updateMessage = (message: ChatMessageListItem) => {
    queryClient.setQueryData<InfiniteData<ChatMessageListItem[]>>(
      queryKey,
      (messages) =>
        messages
          ? {
              ...messages,
              pages: [
                ...messages.pages.map((page) => [
                  ...page.map((item) =>
                    item._id === message._id ? { ...item, ...message } : item,
                  ),
                ]),
              ],
            }
          : messages,
      {
        updatedAt: Date.now(),
      },
    );
  };

  return { updateMessage };
};
